<form class="form-container" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
  <div>
    @if (resetWithCode) {
      <app-custom-input
        [formControlName]="'code'"
        [type]="'text'"
        [id]="'confirmation-code'"
        [label]="LABEL_CONSTANT.CODE"
        [icon]="'user-input-icon.svg'"
        [required]="true"
      />
      @if (userAllowedTimes > maxUserAllowedTimes) {
        <span class="form-error">{{ LABEL_CONSTANT.SEND_CODE_MAX_TRIES_MESSAGE }}</span>
      }
      <div class="button-container">
        <app-button
          [type]="'button'"
          [disable]="resetCodeSent || userAllowedTimes > maxUserAllowedTimes"
          (click)="getCode()"
          [label]="LABEL_CONSTANT.SEND_AGAIN_TEXT(countdown > 0 ? '(' + countdown + 's)' : '')"
          [isLoader]="resetCodeSent"
          [isHideLabel]="false"
          [className]="'primary-button resend-btn'"
        />
      </div>
    }
    <app-custom-input
      [formControlName]="'password'"
      [type]="'password'"
      [id]="'password'"
      [label]="LABEL_CONSTANT.PASSWORD"
      [icon]="'lock.svg'"
      [showHide]="true"
      [required]="true"
      [isPasswordValidator]="true"
    />
    <app-custom-input
      [formControlName]="'confirmPassword'"
      [type]="'password'"
      [id]="'confirm-password'"
      [label]="LABEL_CONSTANT.CONFIRM_PASSWORD"
      [icon]="'lock.svg'"
      [showHide]="true"
      [required]="true"
    />
    <control-messages [control]="resetPasswordForm" />
  </div>
  <app-button
    [type]="'submit'"
    [className]="'primary-form-button'"
    [label]="resetWithCode ? LABEL_CONSTANT.CHANGE : LABEL_CONSTANT.UPDATE"
  />
  <div class="nav-link">
    <a (click)="switchToLoginFlow()">{{ LABEL_CONSTANT.LOGIN }}</a>
  </div>
</form>
